import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
import { CompanyConfig } from "@/lib/common/acm";
import Url from "@/lib/common/url";
import { Question } from "@/lib/model/question/question";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ColorQuestionAnswerResult
} from "@/lib/model/exam/result";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import { FingerCheckResult } from "@/lib/model/exam/result";
import ColorTest from "@/views/paper/components/eye-color.vue";
import ResultDetails, {
  PaperResult,
  ZhuoMuNiao
} from "@/views/news/resultInfo";

const RoseRadius0 = 23;
const RoseRadius1 = 75;
//玫瑰图配置
const echartsRoseOption = {
  title: {
    show: false,
    text: "不符合", //主标题文本
    left: "center",
    top: "center",
    textStyle: {
      // fontFamily: "微软雅黑",
      fontSize: 36
      // fontWeight: "bold",
      // color: "",
      // align: "center",
      // lineHeight: 25
    }
  },
  tooltip: {
    formatter: (p: any, d: any) => {
      return `<div class="sunTip" style="background:${p?.data?.itemStyle.color}!important" >${p?.data?.name}</div>`; //去掉了得分：${p?.data?.value}
    },
    className: `sunTipBox`
  },
  series: [
    //底层
    {
      show: false,
      name: "维度最大值",
      type: "pie",
      silent: true,
      borderColor: "#ffffff",
      // borderWidth: [2],
      // radius: [80,250],
      radius: [String(RoseRadius0) + "%", String(RoseRadius1) + "%"],
      // radius:"100%",
      center: ["50%", "50%"],
      roseType: "area",
      itemStyle: {
        borderRadius: [2, 4],
        color: "#F2F6FF",
        borderColor: "#ffffff",
        borderWidth: [2]
      },
      data: [],
      label: {
        show: true,
        padding: [5, 0, 0, 0],
        // 在文本中，可以对部分文本采用 rich 中定义样式。
        // 这里需要在文本中使用标记符号：
        // `{styleName|text content text content}` 标记样式名。
        // 注意，换行仍是使用 '\n'。
        // formatter: (d: any) => {
        //   return [`${d.name}`, `{b|${d.data.hisScore}}{c|/${d.value}}`].join(
        //     "\n"
        //   );
        // },
        // rich: {
        //   b: {
        //     fontSize: 18,
        //     fontWeight: "bold",
        //     lineHeight: 1,
        //     color: "#111111",
        //     verticalAlign: "top",
        //     align: "left"
        //   },
        //   c: {
        //     fontSize: 12,
        //     fontWeight: "normal",
        //     lineHeight: 17,
        //     color: "#666666",
        //     verticalAlign: "bottom",
        //     align: "left"
        //   }
        // },
        lineHeight: 20,
        color: "#111111",
        fontSize: 14,
        fontWeight: "bold"
      },
      labelLine: {
        show: false,
        length: 35,
        length2: 0,
        lineStyle: {
          color: "red"
        }
      },
      animationType: "scale"
    },
    // 阴影层
    // {
    //   silent: true,
    //   name: "阴影",
    //   type: "pie",
    //   radius: ["15%", "76.53%"],
    //   //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
    //   //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per

    //   center: ["50%", "50%"],
    //   roseType: "area",
    //   data: [
    //     { value: 85, name: "data 1", itemStyle: { color: "#479CFF80" } },
    //     { value: 25, name: "data 2", itemStyle: { color: "#9DBDFA75" } },
    //     { value: 30, name: "data 1", itemStyle: { color: "#479CFF80" } },
    //     { value: 35, name: "data 4", itemStyle: { color: "#9BEEFC80" } },
    //     { value: 15, name: "data 5", itemStyle: { color: "#9DBDFA75" } },
    //     { value: 45, name: "data 6", itemStyle: { color: "#9BEEFC80" } }
    //   ],

    //   itemStyle: {
    //     // color: "rgba(255, 84, 141, 0.46)",
    //     borderWidth: [0],
    //     shadowColor: "blue",
    //     // opacity:0.4,
    //     shadowBlur: [0],
    //     shadowOffsetX: 0,
    //     shadowOffsetY: 0,
    //     borderRadius: [6, 12],
    //     borderType: "solid"
    //     // borderCap: "square",
    //   },
    //   label: {
    //     show: false,
    //     position: "center"
    //   },

    //   animationType: "scale"
    // },
    //数据层
    {
      silent: false,
      name: "",
      type: "pie",
      radius: [String(RoseRadius0) + "%", String(RoseRadius1) + "%"],
      //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
      //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per

      center: ["50%", "50%"],
      roseType: "area",
      data: [
        {
          value: 80,
          name: "data 1",
          itemStyle: {
            color: "#525FFF"
          }
        },
        { value: 20, name: "data 2", itemStyle: { color: "#FF5479" } },
        { value: 30, name: "data 1", itemStyle: { color: "#525FFF" } },
        { value: 30, name: "data 4", itemStyle: { color: "#9BEEFC" } },
        { value: 10, name: "data 5", itemStyle: { color: "#FF5479" } },
        { value: 40, name: "data 6", itemStyle: { color: "#9BEEFC" } }
      ],
      itemStyle: {
        color: "#525FFF",
        borderColor: "#ffffff",
        borderWidth: [2],
        borderRadius: [2, 4]
        // borderType: "solid"
      },
      label: {
        show: false
      },
      emphasis: {
        scale: true,
        label: {
          show: false
        }
      },
      animationType: "scale"
    },
    //卡边框
    {
      name: "透明层",
      type: "pie",
      silent: false,
      borderColor: "#ff0000",
      radius: [String(RoseRadius1 + 7) + "%", String(RoseRadius1 + 7) + "%"],
      center: ["50%", "50%"],
      roseType: "area",
      itemStyle: {
        color: "rgba(1,1,1,0)",
        borderColor: "#525FFF",
        borderWidth: [1],
        borderType: [5, 8],
        borderDashOffset: 2
      },
      data: [1],
      label: {
        show: false
      },
      labelLine: {
        show: false,
        length: 0,
        length2: 0
      },
      emphasis: {
        scale: false,
        label: {
          show: false
        }
      },
      animationType: "scale"
    }
  ]
};
//折线模拟图配置
const echartsLineOption = {
  title: {
    show: false,
    text: "Stacked Line"
  },
  tooltip: {
    show: false,
    trigger: "axis"
  },
  legend: {
    show: false,
    data: []
  },
  grid: {
    left: "150",
    right: "5",
    bottom: "0",
    top: "5%",
    height: "250",
    containLabel: false
  },
  toolbox: {
    show: false
  },
  xAxis: {
    // show: false,
    type: "category",
    boundaryGap: false,
    max: 100,
    min: 0,
    maxInterval: 1,
    minInterval: 1
    // data: [1,22,3,4,5,]
  },
  yAxis: {},
  series: [{}]
};
//推荐等级
enum AiStatus {
  "不推荐 🤨" = 10,
  "一般 🙂" = 20,
  "推荐 👍" = 30,
  "非常推荐 🥳" = 40
}
enum AiStatusStudent {
  "表现较差 🤨" = 10,
  "表现一般 🙂" = 20,
  "表现良好 👍" = 30,
  "表现优秀 🥳" = 40
}
//异常项 名称
enum errorEnum {
  "screenshot" = "小程序防截屏",
  "mobileJoinCount" = "小程序防切屏",
  "replacePerson" = "换人检测",
  "readCheating" = "念稿检测",
  "nameIdCheck" = "二要素核验",
  "faceCheck" = "人脸核验", //之前 身份认证
  "bgCheck" = "背调结果",
  "bgCheckSocial" = "社会安全风险",
  "bgCheckFinancial" = "金融风险",
  "finger" = "手部综合检测",
  "webJump" = "Web防切屏",
  "eyeColor" = "辨色检测",
  "faceDetection" = "露脸检测",
  "bgCheckIdentity" = "手机号实名认证",
  "readingDetection" = "念稿检测"
}
//异常项 新版报告页不展示的项
const hideErrorEnum = ["readCheating", "bgCheck"];

//异常项 默认文案
const errorEnumText = ["信息不足，未完成检测", "不通过", "通过"];

//异常项 对应文案 详情用
const errorEnumTextEX = {
  // "example" : ["未作答文案000","异常文案111","正常文案222"],
  faceCheck: ["未进行身份核验", "异常", "通过"],
  nameIdCheck: ["未检测", "未通过", "通过"],
  bgCheckSocial: ["社会安全未检测", "异常", "通过"],
  bgCheckFinancial: ["金融风险未检测", "异常", "通过"],
  finger: ["未进行手部检测", "异常", "通过"],
  replacePerson: ["未进行换人检测", "异常", "通过"],
  webJump: ["防切屏未检测", "异常", "通过"],
  screenshot: ["防截屏未检测", "异常", "通过"],
  mobileJoinCount: ["防切屏未检测", "异常", "通过"],
  eyeColor: ["未进行辨色检测", "异常", "通过"],
  faceDetection: ["未进行露脸检测", "异常", "通过"],
  bgCheckIdentity: ["手机号实名未查询", "异常", "通过"],
  readingDetection: ["未检测", "异常", "通过"]
};

//异常项 头部用文案
const errorTopText = {
  // "example" : ["未作答文案000","异常文案111","正常文案222"],
  faceCheck: ["未进行身份核验", "身份核验异常", "身份核验通过"],
  nameIdCheck: ["二要素核验未检测", "二要素核验异常", "通过"],
  bgCheckSocial: ["社会安全未检测", "社会安全异常", "社会安全通过"],
  bgCheckFinancial: ["金融风险未检测", "金融风险异常", "金融风险通过"],
  finger: ["未进行手部检测", "手部检测异常", "手部检测通过"],
  replacePerson: ["未进行换人检测", "换人检测异常", "换人检测通过"],
  webJump: ["防切屏未检测", "切屏异常", "切屏通过"],
  screenshot: ["防截屏未检测", "截屏异常", "截屏通过"],
  mobileJoinCount: ["防切屏未检测", "切屏异常", "切屏通过"],
  eyeColor: ["未进行辨色检测", "辨色检测异常", "辨色检测通过"],
  faceDetection: ["未进行露脸检测", "露脸检测异常", "露脸检测通过"],
  bgCheckIdentity: ["手机号实名未查询", "手机号实名异常", "手机号实名通过"],
  readingDetection: ["念稿检测未检测", "念稿检测异常", "念稿检测通过"]
};
// 风险等级评定
const levelToRisk = {
  // 0:旧数据 1:低等级 2:中等级 3:高登记 4:异常等级
  0: "旧数据",
  1: "存在轻微风险",
  2: "存在中风险",
  3: "存在高风险",
  4: "存在异常风险"
};
//异常项 展示用 字段
export type errorInfoType = {
  name: string; //异常项名称
  type: number; // 0 1 2  数据不足 异常 正常
  topValue: string; //头部说明文案
  value: string; //具体说明文案
  task: string; //类型
  isShow: boolean; // 是否展开
};
//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

@Component({ components: { ColorTest } })
export default class ResultAiTs extends Vue {
  $refs!: {
    echartsRose: HTMLCanvasElement;
    echartsSuperLine: HTMLCanvasElement;
    bar1: HTMLElement[];
    bar2: HTMLElement[];
    PCvideo: HTMLElement[];
    switchTabAnchor: HTMLDivElement;
  };
  testList: errorInfoType[] = []; //检测项
  barLight1 = 0; //进度条刻度 单选
  barLight2 = 0; //进度条刻度 编程
  dataAllReady = false; //数据是否加载完成
  connectCode = "";
  candidate = new Candidate(); //候选人信息 主表
  all = new CandidateResult(); //候选人信息 所有表
  //   examData: any = { paperScore: 0, score: 0 }; //笔面试报告数据
  AIMessageList: any[] = []; //AI标签
  pdfIng = false; //下载pdf中
  showAiQuestion = true; //ai回答记录展开收起
  showExamQuestion = true; //笔面试记录
  showTT = false;
  mindData = new Answer();
  fk = "";
  public isNormalValue = false; // 是否常模 (非分组时 老规则)
  normalPercent = 0;
  public isStudent = false; //是否学生模考版
  public showMoreImgWeb = false; //是否展示更多图片web截图
  public showMoreImgWebH5 = true; // h5

  item1Img = require("../../../assets/mind/log-bg.png");
  item1H5Img = require("../../../assets/mind/h5-bg.png");

  // 视频显示Svg
  isShowSvgId = "";
  //是否展示参考答案
  get showAnswerFlag() {
    //非维度组  需求变更：旧版不展示参考答案
    const p1 = this.all.configGroup.showType !== 1 && false;
    //是维度组 且 开启展示
    const p2 =
      this.all.configGroup.showType === 1 &&
      this.all.configGroup.showReferenceAnswer === 1;
    return p1 || p2;
  }

  //是否展示AI评价 旧逻辑 暂存，新逻辑走 ReportShowConfig
  get showAiEvaluateFlag() {
    //非维度组
    const p1 = this.all.configGroup.showType !== 1;
    //是维度组 且 开启展示
    const p2 =
      this.all.configGroup.showType === 1 &&
      this.all.configGroup.suggestType !== 0;
    return p1 || p2;
  }

  //是否分组展示
  public get isGroup() {
    return this.all.configGroup.showType === 1;
  }
  //模块展示
  public Show(p: string) {
    return this.all.reportShowConfig?.[p] !== 1;
  }
  //HR阅过卷
  public get isHrChanged() {
    return (
      this.candidate.auditStatus !== 0 && this.candidate.auditMember !== "AI"
    );
  }
  public get hrResEnum() {
    const enumHr = {
      0: "待评估",
      1: "通过",
      2: "待定",
      3: "拒绝"
    };
    return enumHr[this.candidate.auditStatus] || "-";
  }

  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }

  getResLogo() {
    if (this.isStudent) {
      return AiStatusStudent[this.candidate.aiRecommendStatus] || "";
    } else {
      return AiStatus[this.candidate.aiRecommendStatus] || "";
    }
  }

  get colorTestConfig(): ColorQuestionAnswerResult {
    return (
      this.all?.answerList?.find(item => item.type === 102)
        ?.colorQuestionAnswerResult || new ColorQuestionAnswerResult()
    );
  }

  getDimTagColor(dimName: string) {
    const colorConfig = getDimensionColor(dimName);
    // return {
    //   color: colorConfig["color"],
    //   bgColor: colorConfig["background-color"]
    // };
    return {
      color: "#5C64AC",
      bgColor: "#EBEDFF"
    };
  }
  //是否已经完成评分
  get markOver() {
    return this.candidate.aiProcessStatus === 3;
  }
  //是否隐藏手机号
  get isHidePhone() {
    return CompanyConfig.getInstance().isHidePhone === 1;
  }

  // 基本信息字段
  get paramList() {
    this.candidate.paramList.forEach(p => {
      //格式化多选
      if (["multiChoice"].includes(p.inputType)) {
        let v = ``;
        const list = JSON.parse(p.value || "[]");
        list.forEach((item: any) => {
          v += item + "，";
        });
        p.value = v.substring(0, v.length - 1);
      }
      //格式化二级多选
      if (["multiChoice2"].includes(p.inputType)) {
        let v = ``;
        const obj = JSON.parse(p.value || "{}");
        for (const k in obj) {
          obj[k].forEach((item: any) => {
            v += k + "/" + item + "，";
          });
        }
        p.value = v.substring(0, v.length - 1);
      }
    });
    return this.candidate.paramList.filter(item => {
      return [
        // "编号",
        // "姓名",
        // "手机",
        "身份证号后6位",
        "身份证号",
        "学历",
        "邮箱",
        "最近一份工作单位",
        "学校",
        "专业",
        "年龄",
        "性别",
        "身份证地址",
        "出生地",
        "身高(厘米)",
        "体重(斤)",
        "身体质量指数(BMI)"
      ].includes(item.name);
    });
  }
  //用户自定义字段
  get paramListDIY() {
    return this.candidate.paramList.filter(item => {
      return ![
        "编号",
        "姓名",
        "手机",
        "身份证号后6位",
        "身份证号",
        "学历",
        "邮箱",
        "最近一份工作单位",
        "学校",
        "专业",
        "年龄",
        "性别",
        "身份证地址",
        "出生地",
        "身高(厘米)",
        "体重(斤)",
        "身体质量指数(BMI)"
      ].includes(item.name);
    });
  }
  get questionList() {
    console.log(this.all.questionList);
    return this.all.questionList.filter(q => [1, 7, 6, 8, 5].includes(q.type));
  }
  get answerList() {
    return this.all.answerList.filter(a => [1, 7, 6, 8, 5].includes(a.type));
  }
  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }
  get getAttachmentType() {
    const type = this.candidate.attachmentUrl.split(".")[
      this.candidate.attachmentUrl.split(".").length - 1
    ];
    return type ? "." + type : "";
  }
  fingerResText(i: number) {
    return enumFinger[i];
  }
  showMoreImgFace = false;
  //是否折叠图片 露脸检测
  get showMoreBtnFace() {
    return (
      this.candidate.faceDetectionResult.imgList.length > 6 &&
      !this.showMoreImgFace
    );
  }
  //展示出的图片 露脸检测
  get getImgListFace() {
    if (this.showMoreBtnFace) {
      return this.candidate.faceDetectionResult.imgList.slice(0, 5);
    } else {
      return this.candidate.faceDetectionResult.imgList;
    }
  }

  //10 20 30 分三档时 颜色值
  getColor30(dim: AI | AIGroup) {
    return dim.dimensionLevel === 30
      ? "#00bd82ff"
      : dim.dimensionLevel === 20
      ? "#ff8c04"
      : "#ef483fff";
  }
  //10 20 30 40 分四挡时 颜色值
  getColor40(dim: AI | AIGroup) {
    //
  }
  //计算维度AI推荐级别
  getLevel(dim: AI | AIGroup) {
    const res = { text: "未评级", level: 0 };
    if (dim.dimensionLevel === 10) {
      res.level = 3;
      res.text = "欠佳";
    } else if (dim.dimensionLevel === 30) {
      res.level = 1;
      res.text = "优秀";
    } else if (dim.dimensionLevel === 20) {
      res.level = 2;
      res.text = "中等";
    }
    return res;
  }
  //计算总评AI推荐级别
  getResLevel(a = this.candidate.scoreAi, b = this.all.scoreAll) {
    const per = Math.round((a / b) * 100);
    if (per < 30) {
      return "欠佳";
    } else if (per > 70) {
      return "优秀";
    } else {
      return "中等";
    }
  }
  getBlankCandidateAnswer(q: number) {
    let res = ``;
    const list = this.all.answerList[q].blanks;
    const isRight = this.all.answerList[q].blanksIsRight;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d}）【${isRight[i] ? "正确" : "错误"}】；`;
    });
    return res;
  }
  getBlankAnswer(q: number) {
    const list = this.all.questionList[q].blankQuestionConfig.answerList;
    let res = ``;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d.words}）；`;
    });
    return res;
  }

  // 常模总体表现体现
  getNormal() {
    enum normalValueColor {
      "优秀" = "#00bd82ff",
      "中等" = "#ff8c04",
      "欠佳" = "#ef483fff"
    }
    const flag =
      this.normalPercent < 30
        ? "欠佳"
        : this.normalPercent > 70
        ? "优秀"
        : "中等";
    return [flag, normalValueColor[flag]];
  }
  //分组 组评价
  getResTextByGroup(dim: AIGroup) {
    let t = ``;
    t = `候选人在本次AI面试的表现为<span class='ac ac20' style='color:${this.getColor30(
      dim
    )}'>${dim.dimensionLevelDesc}</span>`;
    return t;
  }

  //不分组 总体评价
  get getResTextLong() {
    let text = "";
    const color =
      this.getResLevel() === "优秀"
        ? "#00bd82ff"
        : this.getResLevel() === "中等"
        ? "#ff8c04"
        : "#ef483fff";

    if (this.isNormalValue) {
      const arr = this.getNormal();
      //在本次有效测评的候选人群体中超过了<span class='ac'>${this.countOverPercent}%</span>的候选人。
      // ${this.candidate.showName}
      return `候选人在本次AI面试的表现为<span class='ac ac20' style='color:${arr[1]}'>${arr[0]}</span>`;
    }
    if (this.isStudent) {
      // 在本次有效测评的<span class='ac'>${   this.all.candidateCount.allSubmit }</span>名候选人群体中超过了<span class='ac'>${  this.countOverPercent }%</span>的候选人。
      text = `你在本次AI面试中总体表现为<span class='ac ac20'>${this.getResLevel()}</span>`;
    } else {
      //可以考虑进入后续环节。在本次有效测评的<span class='ac'>${this.all.candidateCount.allSubmit}</span>名候选人群体中超过了<span class='ac'>${this.countOverPercent}%</span>的候选人。
      text = `候选人在本次AI面试中总体表现为<span class='ac ac20' style='color:${color}'>${this.getResLevel()}</span>`;
      // ${
      //   this.candidate.showName
      // }在${维度名称}、维度上表现优异;在${维度名称}维度上表现一般；在${维度名称}维度上表现欠佳。
    }
    return text;
  }

  get countOverPercent() {
    const per =
      Math.round(
        ((this.all.candidateCount.allLowerSubmit +
          this.all.candidateCount.allSameSubmit) *
          100) /
          this.all.candidateCount.allSubmit
      ) || 0;
    return per > 100 ? 100 : per;
  }
  get aiKeyElementTextBad() {
    return this.all.aiComment.aiKeyElementTextBad;
  }
  get aiKeyElementTextGood() {
    return this.all.aiComment.aiKeyElementTextGood;
  }

  //计算返回按钮位置
  setFixed() {
    const WH: HTMLElement = this.$refs["full"] as HTMLElement;
    const w = Number(WH?.clientWidth) / 2 - 450 - 20;
    return w + "px";
  }
  tid = "";
  //入口
  open() {
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    //主表
    return Candidate.get({ connectCode: this.connectCode, tid: this.tid })
      .then(res => {
        res.paramList = res.paramList.filter(d => {
          return (
            d.isShow === 1 &&
            (!this.isHidePhone || (this.isHidePhone && d.name !== "手机"))
          );
        });
        this.candidate = res;
        console.log(this.candidate);

        return CandidateResult.get({
          connectCode: this.connectCode,
          tid: this.tid
        }); //所有表
      })
      .then(r => {
        this.all = r;
        //不分组时 所有维度均为常模维度 才按照常模模式展示
        this.isNormalValue = this.all.dimensionReport.every(
          item => item.hasNormData === 1
        );
        this.isStudent = this.all.configGroup.suggestType === 2;
        this.$nextTick(() => {
          //不分组时 所有维度均为常模维度 才按照常模模式展示
          this.isNormalValue = this.all.dimensionReport.every(
            item => item.hasNormData === 1
          );
          this.isStudent = this.all.configGroup.suggestType === 2;
          this.setCompanyIcon();
          this.AIMessageList = r.dimensionReportMessage;
          this.listenVideo(); //视频监听
          this.setMindData(); //标准心理测试结果

          this.getTestInfo(); //处理异常标签
          this.$forceUpdate();
          if (!this.isMobile()) {
            this.navnum();
          }
          this.dataAllReady = true;
          this.$nextTick(() => {
            this.setEcharts(); //绘制ec
          });
        });
      })
      .finally(() => {
        //滚动监听
        this.$nextTick(() => {
          window.addEventListener("scroll", (e: any) => {
            this.handleScroll();
          });
        });
      });
  }
  public heightEnough = false;
  getHeightEnough() {
    this.heightEnough = (this.$refs["WH"] as HTMLElement).clientHeight > 1900;
  }

  // 不分组 常模数据收集处理 迭代后不用了 ，暂留
  get normalValueList() {
    const dList = Array.from(new Set(this.all.dimensionReport));
    let sceneMinAiScoreTal = 0;
    let sceneMaxAiScoreTal = 0;
    let scoreTal = 0;
    let scoreAiTal = 0;
    let scoreAllTal = 0;
    // 整理总体表现
    const newItem = dList.reduce((pre, cur, i, list) => {
      sceneMinAiScoreTal += cur.sceneMinAiScore * (cur.scoreAll / 100);
      sceneMaxAiScoreTal += cur.sceneMaxAiScore * (cur.scoreAll / 100);
      scoreTal += cur.score * (cur.scoreAll / 100);
      scoreAiTal += cur.scoreAi * (cur.scoreAll / 100);
      scoreAllTal += cur.scoreAll * (cur.scoreAll / 100);
      if (i === list.length - 1) {
        pre.sceneMinAiScore = Number(sceneMinAiScoreTal);
        pre.sceneMaxAiScore = Number(sceneMaxAiScoreTal);
        pre.score = Number(scoreTal);
        pre.scoreAi = Number(scoreAiTal);
        pre.scoreAll = Number(scoreAllTal);
      }
      return pre;
    }, new AI());
    dList.unshift(newItem);
    // 数据返回处理
    const list = dList.map((item, index) => {
      const percent = Math.round((item.scoreAi / item.scoreAll) * 100);
      if (index === 0) this.normalPercent = percent;
      return {
        weight:
          index === 0
            ? "权重"
            : `${((Number(item.scoreAll) / 100) * 100).toFixed(0)}%`,
        dimension: item.dimension || "总体表现",
        percent: item.dimensionNormPercent,
        rightStart: item.sceneMinAiScore * 6.53,
        lineLong: Math.ceil(
          (item.sceneMaxAiScore - item.sceneMinAiScore) * 6.53
        ),
        region: [item.sceneMinAiScore, item.sceneMaxAiScore]
      };
    });
    return list;
  }
  // 分组的 常模数据展示
  normalValueListGroup(group: AIGroup) {
    const dList = Array.from(new Set(group.dimensionList));
    const list = dList.map((item, index) => {
      return {
        weight: `${Math.floor(item.dimensionWeight * 100)}%`,
        dimension: item.dimension,
        percent: item.dimensionNormPercent,
        unanswered: item.unanswered
      };
    });
    // 子维度数量>1  则统计总体表现     迭代：全都不统计总体表现
    // if (group.dimensionList.length > 1) {
    //   const firstItem = {
    //     weight: "权重",
    //     dimension: "总体表现",
    //     percent: group.dimensionNormPercent,
    //     unanswered: group.unanswered
    //   };
    //   list.unshift(firstItem);
    // }
    return list;
  }

  //绘制EC
  setEcharts() {
    //玫瑰图数据
    const dList = this.all.dimensionReport;
    const allData: any = [];
    const scoreData: any = [];

    let allDataMax = 0; //维度总分最大值
    let scoreDataMax = 0; //维度得分最大值
    dList.forEach(d => {
      //维度得分比例
      const percent = Math.round(
        ((d.scoreAi < 0 ? 0 : d.scoreAi) / d.scoreAll) * 100
      );
      const color =
        percent >= 80 ? "#525FFF" : percent >= 60 ? "#9BEEFC" : "#9DBDFA";
      // const judge = percent >= 80 ? "良好" : percent >= 60 ? "中等" : "较差";
      //维度满分不为0 则展示
      if (d.scoreAll !== 0) {
        //维度满分
        allData.push({
          name: d.dimension,
          value: d.scoreAll < 0 ? 0 : d.scoreAll,
          hisScore: d.scoreAi
        });
        //维度得分
        scoreData.push({
          name: d.dimension,
          value: d.scoreAi < 0 ? 0 : d.scoreAi,
          itemStyle: { color: color }
        });
      }
      allDataMax = d.scoreAll > allDataMax ? d.scoreAll : allDataMax;
      scoreDataMax = d.scoreAi > scoreDataMax ? d.scoreAi : scoreDataMax;
    });
    //计算数据比例
    //每百分之一长度代表的值：per = 外圈最高分 /（外圈外边百分比-外圈内边百分比）；
    //内圈外百分比 = 内圈内百分比 +  内圈最高分 / per
    echartsRoseOption.series[1].radius[1] =
      String(
        (
          RoseRadius0 +
          scoreDataMax / (allDataMax / (RoseRadius1 - RoseRadius0))
        ).toFixed(2)
      ) + "%";
    echartsRoseOption.series[0].data = allData;
    echartsRoseOption.series[1].data = scoreData;
    // echartsRoseOption.series[2].data = allData;// 透明层
    this.fk = String(this.candidate.scoreAi);
    if (this.isMobile()) {
      echartsRoseOption.series[0].label.fontSize = 12;
      (echartsRoseOption.series[0].labelLine as any).length = 20; //10
      //   echartsRoseOption.series[1].silent = true;
    }
    if (this.$refs.echartsRose) {
      const ecRose = echarts.init(this.$refs.echartsRose);
      ecRose.setOption(echartsRoseOption);
    }

    //折线图  利用百分比 模拟X轴是否存在对应数据
    echartsLineOption.series = [];
    const mineScore: number[][] = [];
    dList.forEach((d, i: number) => {
      const percent = Math.round((d.scoreAi / d.scoreAll) * 100);
      // if (percent !== 0) {
      //展示非0的得分
      mineScore.push([percent, i + 1]);
      // }

      //分数分布范围
      const scoreIn = [
        Math.round((d.examMinAiScore / d.scoreAll) * 100),
        Math.round((d.examMaxAiScore / d.scoreAll) * 100)
      ];
      const data = [];
      for (let ii = 0; ii < 100; ii++) {
        // if (ii >= scoreIn[0] && ii <= scoreIn[1]) {
        //   data.push(i + 1);
        // } else {
        //   data.push("");
        // }

        //需求变更 去掉范围虚线
        data.push("");
      }
      echartsLineOption.series.push({
        silent: true,
        symbolSize: 0,
        lineStyle: {
          type: [2, 5],
          color: "#5A6065",
          width: 2,
          join: "round"
        },
        name: "dimension" + i,
        type: "line",
        stack: "stack" + i,
        data: data
      });
    });
    //本人分数 用散点图
    echartsLineOption.series.push({
      data: mineScore,
      animation: false,
      symbolSize: 12,
      itemStyle: {
        color: "#525fff"
      },
      type: "scatter",
      silent: true
    });
    //y轴
    echartsLineOption.yAxis = {
      // show: false,
      silent: true,
      minInterval: 1,
      maxInterval: 1,
      type: "value",
      splitLine: {
        show: false
      },
      axisLabel: {
        color: "#111111",
        margin: 150,
        align: "left",
        width: "160",
        overflow: "breakAll",
        formatter: function(value: any, index: any, some: any) {
          if (index === 0) return;
          if (index > dList.length) return;
          //维度权重
          let per = (Number(dList[index - 1].scoreAll) / 100) * 100;
          per = Number(per.toFixed(0));
          return `${per}%  ${dList?.[index - 1]?.dimension}`;
        }
      }
    };
    // console.log(echartsLineOption);
    if (this.$refs.echartsSuperLine) {
      const ecSl = echarts.init(this.$refs.echartsSuperLine);
      ecSl.setOption(echartsLineOption);
    }
  }
  //检测信息 异常正常全量
  getTestInfo() {
    if (this.all.errorInfoList.length) {
      this.all.errorInfoList.forEach((d: any) => {
        if (hideErrorEnum.includes(d.task)) return;
        //是否有特判文案
        const enumEX = errorEnumTextEX?.[d.task]?.[d.result];
        const enumEXTop = errorTopText?.[d.task]?.[d.result];
        const specialText = this.getSpecialText(d);
        const {
          socialInfoStatus,
          socialInfoErrorLevel,
          financialRiskStatus,
          financialRiskErrorLevel
        } = this.candidate.bgCheckResult;
        const item = {
          name: errorEnum[d.task],
          type: d.result,
          topValue: enumEXTop || errorEnumText[d.result], //头部文案优先级： 头部单独设置的文案 > 默认
          value:
            specialText || d.resMessage || enumEX || errorEnumText[d.result], //文案优先级： 业务特判 > 接口resMessage > errorEnumTextEX > 默认
          task: d.task,
          isShow: false
        };
        if (
          socialInfoStatus === 3 &&
          d.task === "bgCheckSocial" &&
          socialInfoErrorLevel &&
          socialInfoErrorLevel > 0
        ) {
          item.value = levelToRisk[socialInfoErrorLevel];
        }
        if (
          financialRiskStatus === 3 &&
          d.task === "bgCheckFinancial" &&
          financialRiskErrorLevel &&
          financialRiskErrorLevel > 0
        ) {
          item.value = levelToRisk[financialRiskErrorLevel];
        }
        this.testList.push(item);
      });
    }
  }
  getSpecialText(d: any) {
    if (d.task === "eyeColor" && !this.colorTestConfig.showErrResMessage) {
      if (d.result === 1) {
        return "异常";
      }
    }
    return undefined;
  }
  //异常的检测信息
  get errorList() {
    // return this.testList.filter(d => d.type === 1);
    // return this.testList.filter(d => d.type !== 2);
    const sortOrder = { 1: 1, 0: 2, 2: 3 };
    // v3.24.1 背调支线
    console.log(
      this.testList.sort((a, b) => sortOrder[a.type] - sortOrder[b.type])
    );
    return this.testList.sort((a, b) => sortOrder[a.type] - sortOrder[b.type]);
  }
  //所有的检测信息
  get errorNormalList() {
    // return this.testList.filter(
    //   d =>
    //     !["bgCheckSocial", "bgCheckIdentity", "bgCheckFinancial"].includes(
    //       d.task
    //     )
    // );
    return this.testList;
  }
  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }
  //自动暂停其他视频
  listenVideo() {
    const v: any = this.$refs.PCvideo;
    if (!v) return;
    v.forEach((video: any) => {
      video.addEventListener("play", (d: any) => {
        v.forEach((item: any) => {
          if (d.currentTarget.id !== item.id) {
            item.pause();
          }
        });
      });
    });
  }

  //填空题答案
  blankAnswer(answer: any) {
    let t = ``;
    answer.blanks.forEach((d: any, i: number) => {
      t += `${i + 1}.（${d}）    `;
    });
    return t;
  }
  // 下拉区域
  handleScroll() {
    const rect = (this.$refs[
      "showReturnTop"
    ] as HTMLElement)?.getBoundingClientRect();
    if (rect?.top < 0) {
      this.showTT = true;
    } else {
      this.showTT = false;
    }
  }

  //头像占位
  defImg(event: any) {
    this.candidate.photoUrl = "";
    const img = event.srcElement;
    img.onerror = null; //防止闪图
  }
  //客户要的高度
  sendHeight() {
    const t = setInterval(() => {
      if (document.readyState === "complete") {
        window.parent.postMessage(
          { height: document.getElementById("full")?.scrollHeight },
          "*"
        );
        clearInterval(t);
      }
    }, 500);
  }
  getAIComment(answer: any) {
    return answer.aiComment.replaceAll("\n", "<br/>");
  }

  //标准心理结果
  setMindData() {
    this.mindData =
      this.all?.questionAnswerMap?.[110]?.[0]?.answer ??
      this.all?.questionAnswerMap?.[106]?.[0]?.answer ??
      new Answer();
  }

  // 导航标签数
  navnum() {
    // debugger;
    this.$nextTick(() => {
      const a = document
        .querySelectorAll(".card-index .card .icon-box .num")
        .forEach((el: Element, index: number) => {
          el["innerHTML"] = String(index + 1);
        });
      //   document
      //     .querySelectorAll(".big-card")
      //     .forEach((item: Element, index: number) => {
      //       // 标题序号
      //       item.childNodes[0].childNodes[0]["innerText"] = index + 1;
      //     });
    });
  }
  // 是否存在居中播放图标
  isShowSvg(val: string) {
    return (
      val &&
      String(val)
        .substr(-3, 3)
        .toLowerCase() !== "mp3"
    );
  }
  //页面title icon
  setCompanyIcon() {
    if (this.isMobile()) return; //h5不设置
    const company = this.all.exam.company;
    if (company.shortname) {
      document.title = company.shortname.substring(0, 6);
    }
    if (company.companyIcon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link") as HTMLLinkElement;
      }
      if (link) {
        link.rel = "icon";
        link.href = company.companyIcon;
        document.head.appendChild(link);
      }
    }
  }
  showShare = false;

  //分享链接 加密或解密
  copyLink(type?: string) {
    //创建input标签
    const input = document.createElement("input");
    //取路径参数
    const URL = document.URL;
    let param = URL.slice(URL.indexOf("?"));
    //加密的 去掉sid
    if (type !== "visible") {
      const i = param.indexOf("sid");
      if (i !== -1) {
        param = param.slice(0, i - 1);
      }
    }
    //复制值
    input.value = this.candidate.shareHost + param;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    //关闭弹窗
    if (!this.isMobile()) {
      this.$message.success("复制成功");
    } else {
      // (document.getElementsByClassName("pass")[0] as HTMLElement).click();
      this.showShare = false;
    }
  }
  bigImgUrl = "";
  showBigImg = false;
  //查看大图
  openImg(url: string) {
    this.bigImgUrl = url;
    this.showBigImg = true;
  }
  specialJump(item: any) {
    if (item.dimension === "英语") {
      const english = document.querySelector(".englishCard") as HTMLElement;
      english.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    if (item.dimension === "普通话") {
      const mandarin = document.querySelector(".mandarinCard") as HTMLElement;
      mandarin.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
  // 维度-特判英语、普通话等
  specialJumpText(item: any) {
    if (
      item.dimension === "英语" &&
      this.all.englishAssessmentResult.totalLevel >= 0
    ) {
      return `候选人的英语口语水平${
        this.all.englishAssessmentResult.getLevel().tag
      }
			，在本次测评中综合${
        this.all.reportShowConfig.englishAssessmentShowType === 1
          ? "等级"
          : "成绩"
      }${this.all.englishAssessmentResult.totalLevel}${
        this.all.reportShowConfig.englishAssessmentShowType === 1 ? "/9" : ".0"
      }。
			`;
    }
    if (item.dimension === "普通话") {
      return `候选人的普通话水平${
        this.all.chineseAssessmentResult.getEval(this.all).tag
      }
			${
        !this.Show("hiddenIseChineseScorePercent")
          ? ""
          : `，在常模人群中处于${this.all.chineseAssessmentResult.prScore}%分位。`
      }`;
    }
    return item.reportDescription || "暂无评价";
  }

  // tooltip音频播放
  playAudioDesc(q: Question) {
    // 存在音频列表
    const audioList: HTMLAudioElement[] = [];
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: HTMLAudioElement, i: number) => {
      if (
        !audioList.find(
          (audio: HTMLAudioElement) => audio.id === audioElement.id
        )
      ) {
        audioList.push(audioElement);
      }
      audioElement.pause();
    });
    const currentAudio = audioList.find(
      (audio: HTMLAudioElement) => audio.id === `player${q.questionId}`
    );
    if (currentAudio) {
      currentAudio.play();
    } else {
      const audio = document.createElement("audio") as HTMLAudioElement;
      audio.id = `player${q.questionId}`;
      audio.src = q.audioDescUrl;
      document.body.appendChild(audio);
      audio.play();
    }
  }

  get resultData() {
    const result: PaperResult = new PaperResult();
    if (this.candidate.auditStatus === 1) {
      const isZmn = ZhuoMuNiao.isZmn(this.candidate.paramList);
      result.isCompanyZmn = isZmn;
      try {
        const resultData = JSON.parse(this.candidate.resultData);
        if (resultData && resultData[0] && resultData[0].value) {
          result.value = ["已确认", "已放弃"][+resultData[0].value - 1];
        }
      } catch (error) {
        console.log("JSON/error:", error);
      }
    }
    return result;
  }
}
